import { normalizeSportValue, getSportLabel } from '../constants/sports'

// Opciones de deporte para un selector: SOLO los habilitados de la org
// (organization_deportes activos), nunca una lista fija ni el catalogo global.
//
// Si el registro ya trae un deporte que se deshabilito despues, se agrega marcado
// como deshabilitado: sin el, Radix pinta el selector en blanco y al guardar se
// reescribe el valor viejo sin que nadie lo vea. Marcado, se ve lo que hay y no
// se puede volver a elegir.
//
// `actual` acepta uno o varios (los programas llevan una lista). `nombreDe` da el
// nombre de un deporte que ya no viene en orgDeportes (useDeportes().label).
export const opcionesDeporte = (orgDeportes, actual = null, nombreDe = getSportLabel) => {
  const opciones = (orgDeportes || [])
    .map((od) => {
      const id = od.deporte?.id || od.deporte_id
      return { value: id, label: od.deporte?.nombre || nombreDe(id) || id, deshabilitado: false }
    })
    .sort((a, b) => a.label.localeCompare(b.label, 'es'))

  const actuales = (Array.isArray(actual) ? actual : [actual]).filter(Boolean)
  actuales.forEach((valor) => {
    const id = normalizeSportValue(valor)
    if (opciones.some((o) => normalizeSportValue(o.value) === id)) return
    opciones.push({ value: valor, label: `${nombreDe(id) || valor} (deshabilitado)`, deshabilitado: true })
  })

  return opciones
}

// El deporte con que arranca un alta: el primero habilitado, siempre el mismo.
// Vacio si la org no tiene ninguno -- nunca 'flag' por defecto.
export const deportePorDefecto = (orgDeportes) => opcionesDeporte(orgDeportes)[0]?.value || ''

export const SIN_DEPORTES_MSG =
  'Esta organización no tiene deportes habilitados. Pide al administrador de la plataforma que active al menos uno.'

// Plataforma: una org activa que no tiene NINGUN deporte habilitado no puede crear grupos
// ni categorias (20261002). Sin el dato embebido no se marca, para no mentir.
export const orgSinDeportes = (org) =>
  !!org?.active && Array.isArray(org.organization_deportes) &&
  !org.organization_deportes.some((od) => od.active)
